// extracted by mini-css-extract-plugin
export var actions = "_am-8";
export var arrow = "_am-5";
export var card = "_am-0";
export var cardWrapper = "_am-9";
export var fieldName = "_am-3";
export var newValue = "_am-6";
export var oldValue = "_am-4";
export var orangeGlowFade = "_am-c";
export var productSection = "_am-1";
export var scrollToBottom = "_am-b";
export var scrollToBottomAnchor = "_am-a";
export var scrollToBottomIcon = "_am-d";
export var showAllButton = "_am-7";
export var table = "_am-2";